<script lang="ts">
  import { twMerge } from 'tailwind-merge';

  let clazz = '';
  export { clazz as class };
</script>

<div class={twMerge('bg-blue text-white text-center', clazz)}>
  <img src="/teach/t-landing/logo-utheory-green-square.jpg" alt="uTheory Logo" class="mx-auto" />
  <p style="font-size: 22px;" class="max-w-lg mx-auto mt-4 text-xl xs:text-2xl">
    uTheory does it all: planning, teaching, assessing and grading so your students can learn,
    practice and master music theory
  </p>
</div>
